// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"ebe83add","147":"f7dba214","171":"db34fe1f","429":"bc1583aa","453":"b4749c25","466":"b42c0ec3","507":"660613b6","594":"78725bc7","760":"b7531ab9","780":"6a8cc84f","931":"3454bad1"}[chunkId] + ".chunk.js";
};